// import * as bootstrap from 'bootstrap'
import Modal from 'bootstrap/js/dist/modal'
import { DateTime } from 'luxon'
import moment from 'moment'
import { getCurrentEntity, inputElements, maskElements, tagifyElements } from '../app.js'
import { stopAudio } from '../audioPlayer.js'
import { map } from '../constants.js'
import { removeLectureFromAdvayta, updateLecturesInAdvayta } from "../server/advayta"
import { addItemToFirebase, removeItemFromFirebase, updateItemInFirebase } from '../server/firebase.js'
import { clearUploadedFiles, deleteByPath, processFilesToDelete } from "../upload"
import { deleteAudio, saveAudio } from "./audioForm"
import { clearBookFormHighlight, deleteBook, saveBook } from "./bookForm"
import { closeRightPanel } from './panels.js'
import { hideSpinnerOverlay, showSpinnerOverlay } from './spinner.js'
import { addRowInTable, deleteRow, updateRowInTable } from './tabulatorControl.js'
import { showErrorToast, showOkToast } from './toastControl.js'


const closeBtn = document.getElementById('close-btn')
const saveBtn = document.getElementById('save-btn')
const deleteBtn = document.getElementById('delete-btn')
const cancelBtn = document.getElementById('cancel-btn')
const removeFromSiteBtn = document.getElementById('remove-from-site-btn')

closeBtn.addEventListener('click', updateUIAndCLose)
cancelBtn.addEventListener('click', updateUIAndCLose)
saveBtn.addEventListener('click', save)
// delBtnModal.addEventListener('click', deleteItem)
deleteBtn.addEventListener('click', deleteItem)
removeFromSiteBtn.addEventListener('click', removeFromSite)

function updateUIAndCLose() {
  resetMaskValidationUI()
  clearBookFormHighlight()
  closeRightPanel()
  stopAudio()
}

// Функция для сбора данных с формы
export function collectFormData() {
  const tagifyResults = {}
  for (const role of Object.keys(map)) {
    const tagify = tagifyElements[role]
    if (tagify) {
      if (map[role].isSingle) {
        tagifyResults[map[role].fieldName] = tagify.value[0] ?? null
      } else {
        tagifyResults[map[role].fieldName] = tagify.value
      }
    }
  }
  const result = {
    ...tagifyResults,
    key: inputElements.key.value,
    title: inputElements.title.value,
    comment: inputElements.comment.value,
    description: inputElements.description.textContent,
    youtube: inputElements.youtube.value,
    advayta: inputElements.advayta.value,
    seo_title: inputElements.seo_title.value,
    seo_description: inputElements.seo_description.value,
    text: inputElements.text.value,
    text_link: inputElements.text_link.value,
    date: maskElements.date.getDate(),
    duration: maskElements.duration.getTimeStr(),
    preview: inputElements.preview.value,
    paid: inputElements.paid.checked,
    topic: inputElements.topic.value,
    bucket: inputElements.bucket.value,
    path: inputElements.path.value,
    storage_name: inputElements.storage_name.value,
    supabase_file_id: inputElements.supabase_file_id.value,
    lecture_link: inputElements.lecture_link.value
  }
  console.log('Собранные данные формы:', result)
  console.log('Значение поля preview в элементе:', inputElements.preview.value)
  return result
}

function isValidLink(link) {
  return link &&
    typeof link === 'string' &&
    link.trim() !== '' &&
    !link.includes('undefined') &&
    !link.includes('null')
}

// Обработчик событий для кнопки "Сохранить"

async function save() {
  const currentEntity = getCurrentEntity()
  if (currentEntity === 'books') return saveBook()
  if (currentEntity === 'audios') return saveAudio()
  await processFilesToDelete()
  const formData = collectFormData()
  showSpinnerOverlay()
  if (!validateOnSave(formData)) {
    console.log('Заполните даные')
    hideSpinnerOverlay()
    return
  }
  const recordKey = formData.key

  const dataForFB = { ...formData }
  console.log('Данные формы перед обработкой:', formData)
  console.log('Поле preview в formData:', formData.preview)

  //  обновляет и подготавливает списки для сохранеия в базу
  for (const role of Object.keys(map)) {
    const config = map[role]
    if (!config.listName) continue
    if (config.isSingle) {
      dataForFB[config.fieldName] = dataForFB[config.fieldName] ? dataForFB[config.fieldName].key : null
    } else {
      if (Array.isArray(dataForFB[config.fieldName])) {
        dataForFB[config.fieldName] = dataForFB[config.fieldName].reduce((acc, tag) => {
          acc[tag.key] = tag.key
          return acc
        }, {})
      }
    }
  }

  // Если обновить
  if (recordKey) {

    try {
      const response = await updateLecturesInAdvayta(formData)

      if (response) {
        if (response.error) {
          console.log('Ошибка валидации от сервера:', response.error)
          showErrorToast(response.error)
        } else {
          console.log('Ответ от сервера при обновлении:', response)
          dataForFB.text = formData.text = response.text || null

          if (response.preview) {
            dataForFB.preview = formData.preview = response.preview
            inputElements.preview.value = response.preview
            console.log('Обновили превью на:', response.preview)
          }

          const serverLink = response.link

          console.log('Логика обновления ссылки:', {
            currentAdvaitaValue: formData.advayta,
            serverLink,
            isValidServerLink: isValidLink(serverLink)
          })

          if (isValidLink(serverLink)) {
            dataForFB.advayta = formData.advayta = serverLink
            inputElements.advayta.value = serverLink
            console.log('Обновили ссылку на:', serverLink)
          }

          console.log('Финальная ссылка advayta:', dataForFB.advayta)
          dataForFB.paid = formData.paid = response.paid || null
          dataForFB.lecture_link = formData.lecture_link = response.lecture_link || null
        }
      }
      console.log('Данные для сохранения в Firebase при обновлении:', dataForFB)
      console.log('Поле preview в dataForFB:', dataForFB.preview)
      updateRowInTable(recordKey, formData)
      await updateItemInFirebase(dataForFB, map.ENTITIES)
      showOkToast('Запись успешно обновлена')

    } catch (error) {
      console.log(`Ошибка при обновлении '${error}'`)
      const errorMessage = error.message || 'Не удалось обновить запись в базе'
      showErrorToast(errorMessage)
    }
  } else {
    // иначе создание новой записи
    try {
      const key = await addItemToFirebase(dataForFB, map.ENTITIES)
      formData.key = key
      dataForFB.key = key
      const response = await updateLecturesInAdvayta(formData)

      if (response) {
        if (response.error) {
          console.log('Ошибка валидации от сервера:', response.error)
          showErrorToast(response.error)
        } else {
          console.log('Ответ от сервера при создании:', response)
          dataForFB.text = formData.text = response.text || null

          if (response.preview) {
            dataForFB.preview = formData.preview = response.preview
            inputElements.preview.value = response.preview
            console.log('Обновили превью на:', response.preview)
          }

          if (response?.link && isValidLink(response.link)) {
            console.log('Обновляем ссылку advayta:', response.link)
            dataForFB.advayta = formData.advayta = response.link
            inputElements.advayta.value = response.link
          }

          dataForFB.paid = formData.paid = response.paid || null
          dataForFB.lecture_link = formData.lecture_link = response.lecture_link || null

          console.log('Обновляем Firebase с данными:', dataForFB)
          console.log('Поле preview в dataForFB при создании:', dataForFB.preview)
          await updateItemInFirebase(dataForFB, map.ENTITIES)
        }
      }
      addRowInTable(formData)
      showOkToast('Запись успешно создана')
    } catch (error) {
      console.log(`Ошибка при создании '${error}'`)
      const errorMessage = error.message || 'Не удалось создать запись в базе'
      showErrorToast(errorMessage)
    }
  }

  clearUploadedFiles()

  stopAudio()
  hideSpinnerOverlay()
  closeRightPanel()
}

async function deleteItem() {
  const currentEntity = getCurrentEntity()
  if (currentEntity === 'books') return deleteBook()
  if (currentEntity === 'audios') return deleteAudio()
  if (!inputElements.key.value) return // если запись еще не сохранена, то удалять еще нечего
  const modal = new Modal(document.getElementById('confirmDeleteModalRec'))
  const modalBodyEl = document.querySelector('#confirmDeleteModalRec .modal-body p')
  const title = inputElements.title.value
  const date = maskElements.date.getDate()
  const type = tagifyElements.type.value[0].value
  modalBodyEl.innerHTML = `
              <figure class="text-center">
              <blockquote class="blockquote">
                <p>${date} ${type} ${title}</p>
              </blockquote>
              <figcaption class="blockquote-footer">
                удалить навсегда?
              </figcaption>
            </figure>
            `
  const delBtnModal = document.getElementById('confirmDeleteBtnRec')

  modal.show()
  delBtnModal.onclick = async () => {
    try {
      const spinnerEl = delBtnModal.querySelector('span.spinner-border')
      spinnerEl.classList.remove('d-none')
      delBtnModal.setAttribute('disabled', '')
      const key = inputElements.key.value

      if (inputElements.advayta && inputElements.advayta.value) {
        await deleteByPath(inputElements.advayta.value)
      }

      if (inputElements.text && inputElements.text.value) {
        await deleteByPath(inputElements.text.value)
      }

      const result = await removeItemFromFirebase(key, map.ENTITIES)
      removeLectureFromAdvayta(key)
      deleteRow(key)
      closeRightPanel()
      modal.hide()
      spinnerEl.classList.add('d-none')
      delBtnModal.removeAttribute('disabled')
      showOkToast('Запись успешно удалена')
      console.log(`${result}`)
    } catch (error) {
      console.log(`Ошибка при удалении записи: ${error}`)
      showErrorToast('Не удалось удалить запись')
    }
  }
}

// Убрать лекцию ТОЛЬКО с сайта: backend removeLecture удаляет страницу-лекцию +
// mp3/текст на сервере, но запись в каталоге (FBDB) и строка в таблице ОСТАЮТСЯ.
// В отличие от deleteItem, здесь НЕТ removeItemFromFirebase и НЕТ deleteRow.
async function removeFromSite() {
  const currentEntity = getCurrentEntity()
  if (currentEntity !== 'lectures') return
  if (!inputElements.key.value) return
  const modal = new Modal(document.getElementById('confirmDeleteModalRec'))
  const modalBodyEl = document.querySelector('#confirmDeleteModalRec .modal-body p')
  const title = inputElements.title.value
  const date = maskElements.date.getDate()
  const type = tagifyElements.type.value[0] ? tagifyElements.type.value[0].value : ''
  modalBodyEl.innerHTML = `
              <figure class="text-center">
              <blockquote class="blockquote">
                <p>${date} ${type} ${title}</p>
              </blockquote>
              <figcaption class="blockquote-footer">
                Удалить с sanatanadharma.world? Страница лекции и файлы (mp3/текст) будут удалены. Запись в каталоге останется.
              </figcaption>
            </figure>
            `
  const delBtnModal = document.getElementById('confirmDeleteBtnRec')

  modal.show()
  delBtnModal.onclick = async () => {
    try {
      const spinnerEl = delBtnModal.querySelector('span.spinner-border')
      spinnerEl.classList.remove('d-none')
      delBtnModal.setAttribute('disabled', '')
      const key = inputElements.key.value

      // Только сайт: backend removeLecture сам удаляет audio-строку + mp3/текст
      // на сервере (removeFile идемпотентен — existsSync-guard). deleteByPath НЕ
      // вызываем: он мог бросить ДО removeLecture и оставить строку. FBDB и
      // строку в таблице не трогаем.
      await removeLectureFromAdvayta(key)

      closeRightPanel()
      modal.hide()
      spinnerEl.classList.add('d-none')
      delBtnModal.removeAttribute('disabled')
      showOkToast('Убрано с сайта (в каталоге осталось)')
    } catch (error) {
      console.log(`Ошибка при удалении с сайта: ${error}`)
      showErrorToast('Не удалось убрать с сайта')
    }
  }
}

function validateOnSave(formData) {
  let isValid = true
  const dateEl = maskElements.date.iMask.el.input
  const date = formData.date

  if (!moment(date, 'YYYY.MM.DD').isValid()) {
    alert('Неверный формат даты')
    return false
  }

  if (date && isDateInFuture(date)) {
    isValid = updateValidationState(dateEl, false, 'лекция не может быть в будущем')
    return validateTagifyFields(formData) && validateRequiredFields(formData) && isValid
  }
  isValid = updateValidationState(dateEl, formData.date, 'неверный формат даты')
  return validateTagifyFields(formData) && validateRequiredFields(formData) && isValid
}

const isDateInFuture = (dateString) => {
  // Преобразуем строку в объект DateTime
  const inputDate = DateTime.fromFormat(dateString, 'yyyy.MM.dd')

  // Получаем текущую дату
  const today = DateTime.now().startOf('day')

  // Сравниваем даты
  return inputDate > today
}

function validateTagifyFields(formData) {
  let isValid = true
  for (const [key, value] of Object.entries(map)) {
    if (value.isRequired) {
      const tagify = tagifyElements[key]
      const fieldData = formData[key]

      let fieldValid = false
      if (value.isSingle) {
        fieldValid = fieldData && fieldData.key
      } else {
        fieldValid = fieldData && Array.isArray(fieldData) && fieldData.length > 0
      }

      isValid = updateValidationState(tagify.DOM.originalInput, fieldValid, 'обязательное поле', tagify) && isValid
    }
  }
  return isValid
}

function validateRequiredFields(formData) {
  let isValid = true

  const titleEl = inputElements.title
  const titleValid = formData.title && formData.title.trim() !== ''
  isValid = updateValidationState(titleEl, titleValid, 'Название обязательно для заполнения') && isValid

  return isValid
}

export function updateValidationState(el, isValid, message = '', tagify) {
  let feedbackElement = el.nextElementSibling

  if (!feedbackElement || !feedbackElement.classList.contains('invalid-feedback')) {
    feedbackElement = document.createElement('div')
    feedbackElement.classList.add('invalid-feedback')
    el.parentNode.appendChild(feedbackElement)
  }

  el.classList.toggle('is-invalid', !isValid)
  feedbackElement.textContent = isValid ? '' : message
  if (tagify) {
    tagify.DOM.scope.style.borderColor = isValid ? '' : '#DC3545'
  }
  return isValid
}

export function resetAllFields() {
  for (const key in inputElements) {
    inputElements[key].value = ''
  }
  inputElements.description.textContent = '' // это нужно, поскольку используется не textarea, обычный div, который симулирует текстовое поле, чтобы работала подсветка по поиску

  updateValidationState(inputElements.title, true, '')
  updateValidationState(inputElements.description, true, '')

  for (const role of Object.keys(map)) {
    if (!map[role].listName) continue
    const tagify = tagifyElements[role]
    if (!tagify) {
      continue
    }
    tagify.removeAllTags()
    if (map[role].isRequired) updateValidationState(tagify.DOM.originalInput, true, '', tagify)
  }

  resetMaskValidationUI(true)
}

export function resetMaskValidationUI(resetValue = false) {
  const iMaskDate = maskElements.date.iMask
  if (resetValue) {
    iMaskDate.value = ''
    maskElements.duration.iMask.value = ''
  }
  updateValidationState(iMaskDate.el.input, true, '')
}
